export default __webpack_public_path__ + "static/media/medium.b45d7428.gif";